import { useMemo, useState } from 'react';
import { formatStat } from '../lib/gemLogic.js';

export default function StatusPage({ mode, gems, onChange, onPermanentDelete, t }) {
  const items = useMemo(() => gems.filter((g) => g.status === mode), [gems, mode]);
  const [selected, setSelected] = useState(new Set());
  const isTrash = mode === '휴지통';

  function toggleAll() {
    setSelected(selected.size === items.length ? new Set() : new Set(items.map((g) => g.id)));
  }

  function restore() {
    onChange(gems.map((g) => selected.has(g.id) ? { ...g, status: '정상' } : g));
    setSelected(new Set());
  }

  function pendingToTrash() {
    onChange(gems.map((g) => selected.has(g.id) ? { ...g, status: '휴지통' } : g));
    setSelected(new Set());
  }

  return (
    <section className="page-section">
      <div className="section-heading">
        <div><h2>{isTrash ? '🗑️' : '📦'} {isTrash ? t('trash') : t('pending')}</h2><p>{items.length}</p></div>
        <div className="button-row">
          {!!items.length && <button className="secondary" onClick={toggleAll}>{selected.size === items.length ? '선택 해제' : '전체 선택'}</button>}
          {!isTrash && <button className="danger" disabled={!selected.size} onClick={pendingToTrash}>🗑️ {t('moveTrash')} ({selected.size})</button>}
          {isTrash && <><button className="secondary" disabled={!selected.size} onClick={restore}>♻️ {t('restore')} ({selected.size})</button><button className="danger" disabled={!selected.size} onClick={() => onPermanentDelete([...selected]).then(() => setSelected(new Set()))}>🔥 {t('deletePermanent')} ({selected.size})</button></>}
        </div>
      </div>

      {!items.length ? <div className="empty-card">비어 있습니다.</div> : <div className="table-wrap">
        <table className="data-table">
          <thead><tr><th></th><th>ID</th><th>보석</th><th>{t('shape')}</th><th>{t('enhancement')}</th><th>{t('mainStat')}</th><th>{t('subStats')}</th><th>{t('fileName')}</th></tr></thead>
          <tbody>{items.map((g) => <tr key={g.id}>
            <td><input type="checkbox" checked={selected.has(g.id)} onChange={() => setSelected((prev) => { const n = new Set(prev); n.has(g.id) ? n.delete(g.id) : n.add(g.id); return n; })} /></td>
            <td>{g.id}</td><td>{g.name}</td><td>{g.shape}</td><td>+{g.enhancement}</td><td>{formatStat(g.main_stat)}</td><td className="compact-cell">{(g.sub_stats || []).map(formatStat).join(', ')}</td><td className="mono">{g.file_name}</td>
          </tr>)}</tbody>
        </table>
      </div>}
    </section>
  );
}
